import css from './Sidebar.module.css'

export const styles = {
    sidebar: css['sidebar'],
    break: css['sidebar_break'],
    info: css['search_info'],
    infoText: css['search_info_text'],
    menuTitle: css['menu_title']
}